export const schemaValidateUsersList = [
  {
    id: 1,
    field: "id",
    is_in_bdd:false,
    data_type: "id",
    type: "field",
    max_length: 80,
    component_new:"null",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-xs",
    readmore_limit_table: "null",
    show_export_table: true,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 2,
    field: "first_name",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°\"\"“”,.()0-9/\\[\\]#->!+@$_&*:;?%<¿¡©®™~=^-|\\n ]+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 3,
    field: "last_name",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°\"\"“”,.()0-9/\\[\\]#->!+@$_&*:;?%<¿¡©®™~=^-|\\n ]+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 4,
    field: "user_name",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[A-ZÑa-zñáéíóúÁÉÍÓÚ'°\"\"“”,.()0-9/\\[\\]#->!+@$_&*:;?%<¿¡©®™~=^-|\\n ]+$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 5,
    field: "password",
    is_in_bdd:true,
    data_type: "password_new",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: false,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,

    regex: "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\!\@\#\$\%\^\&\*\_\+\=\:\;\,\.\<\>]).*$", 
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 6,
    field: "email",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 7,
    field: "mobile_number",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[0-9]*$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 8,
    field: "phone_number",
    is_in_bdd:true,
    data_type: "string",
    type: "field",
    max_length: 255,
    component_new:"NewInputGeneric",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-l",
    readmore_limit_table: 200,
    show_export_table: true,
    is_required: true,
    validate_minimum: true,
    validate_regex: true,
    regex: "^[0-9]*$",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:true,
    occupation_new:6
  },
  {
    id: 9,
    field: "deleted",
    is_in_bdd:true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new:"null",
    show_in_table: false,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:false,
    occupation_new:6
  },
  {
    id: 11,
    field: "can_login",
    is_in_bdd: true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new: "null",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder: false,
    occupation_new: 6
  },
  {
    id: 12,
    field: "blocked",
    is_in_bdd: true,
    data_type: "boolean",
    type: "field",
    max_length: "null",
    component_new: "null",
    show_in_table: true,
    sort_in_table: true,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: 200,
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder: false,
    occupation_new: 6
  },
  {
    id: 10,
    field: "options",
    is_in_bdd:false,
    data_type: "buttons",
    type: "field",
    max_length: "null",
    component_new:"null",
    show_in_table: true,
    sort_in_table: false,
    style_in_table: "list-table-cell-s",
    readmore_limit_table: "null",
    show_export_table: false,
    is_required: false,
    validate_minimum: false,
    validate_regex: false,
    regex: "null",
    validate_unique: false,
    unique_condition: "null",
    deleted: false,
    activated: true,
    module_text: "admin-user",
    is_placeholder:false,
    occupation_new:6
  }
];